import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import {DocumentsTabService} from '../../services/documents-tab.service';
import * as _ from 'lodash';
import {IDocumentTemplate} from '../documents-tab/interfaces/document-template.interface';
import {DocumentTestData} from '../documents-tab/interfaces/document-test-data.interface';
import {distinctUntilChanged, filter, map} from "rxjs/operators";
import { TestService } from '../../services/test.service';
import { WorkflowService } from '@ispm/workflow/services/workflow.service';

const FINAL_REPORT_TYPE = 'final';

@Component({
  selector: 'ispm-pathway-documents-list',
  templateUrl: './pathway-documents-list.component.html',
  styleUrls: ['./pathway-documents-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PathwayDocumentsListComponent implements OnInit, AfterViewInit {
  public testRelatedDocuments: IDocumentTemplate[] = [];
  public testData: DocumentTestData = new DocumentTestData();
  @ViewChild('list', {static: false}) list: ElementRef;
  finalReportExists: boolean;
  reportTypeToRelease: string;
  testConfiguration: any;
  workflowRevisionFinalStatus: any;

  @Output() documentClicked = new EventEmitter<null>();

  constructor(
    private testService : TestService,
    private workflowService: WorkflowService,
    private  documentsTabService: DocumentsTabService) {
  }

  ngOnInit() {
    this.testData.currentTest = this.workflowService.currentTest;
    this.testData.testNumber = this.workflowService.currentTest.identifiers[0].value;
    const revisions = this.workflowService.currentTest.workflowRequest.revisions;
    this.testData.firstRevisionId = revisions[0].id;
    const testConfiguration = this.testService.testConfiguration;
    if (testConfiguration) {
      this.testRelatedDocuments = [];
      this.finalReportExists = false;
      const templatesSorted = !!testConfiguration.xHtmlReportTemplates && testConfiguration.xHtmlReportTemplates.length > 0 ?
        testConfiguration.xHtmlReportTemplates.sort((doc1, doc2) => {
        return _.has(doc1, 'order') && _.has(doc2, 'order') ? (parseInt(doc1.order) >= parseInt(doc2.order) ? 1 : -1) : 1;
      }) : [];

      templatesSorted.forEach(doc => {
        if (doc.type === FINAL_REPORT_TYPE) {
          this.finalReportExists = true;
          this.reportTypeToRelease = FINAL_REPORT_TYPE;
        }
        let enableGenerateAndDownloadButton = false;
        let generateAndDownloadButtonText = 'Generate';
        if (doc.enableGenerateAndDownloadButton) {
          enableGenerateAndDownloadButton = doc.enableGenerateAndDownloadButton;
        }
        if (doc.generateAndDownloadButtonText) {
          generateAndDownloadButtonText = doc.generateAndDownloadButtonText;
        }
        if (!doc.hasOwnProperty('snapshot') || !doc.snapshot) {
          this.testRelatedDocuments.push(
            {
              title: doc.title,
              type: doc.type,
              version: doc.version,
              reference: doc.reference,
              labels: doc.labels,
              data: doc.data,
              enableGenerateAndDownloadButton: enableGenerateAndDownloadButton,
              generateAndDownloadButtonText: generateAndDownloadButtonText,
              clientDateFormat: doc.clientDateFormat
            }
          );
        }
      });
      this.testConfiguration = testConfiguration;
      this.workflowRevisionFinalStatus = _.get(this.testConfiguration, 'workflowRevisionFinalStatus', undefined);
    }
  }

  ngAfterViewInit(): void {
    // When initialized by signing off, mark as selected the document that was selected before
    this.documentsTabService.loadDocumentSubject.pipe(
      filter(doc => !!doc),
      distinctUntilChanged((doc1, doc2) => doc1.title === doc2.title),
      map(doc => {
        const documentNodes: HTMLElement[] = [].slice.call(this.list.nativeElement.children);
        return documentNodes.findIndex(child => child.innerText === doc.title);
      }),
      filter(index => index >= 0)
    ).subscribe(x => this.markIndexAsSelected(x));

    // Initially select the first document
    this.onSelectedItem(0);
  }

  onSelectedItem(index: number) {
    this.markIndexAsSelected(index);
    this.documentClicked.emit(null); // will switch to the document tab if it is not active
    this.documentsTabService.loadDocumentSubject.next(this.testRelatedDocuments[index]);
  }

  private markIndexAsSelected(index: number) {
    for (let i = 0; i < this.list.nativeElement.children.length; i++) {
      if (i === index) {
        this.list.nativeElement.children[i].style.fontWeight = 'bold';
      } else {
        this.list.nativeElement.children[i].style.fontWeight = 'normal';
      }
    }
  }
}
